import React, { useState, useEffect } from "react";
import { Box, Avatar, Paper, Typography, Fade } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { SmartToy as BotIcon, Loop as LoaderIcon } from "@mui/icons-material";

const TypingIndicator = () => {
  const theme = useTheme();
  const [step, setStep] = useState(0);
  const steps = [
    "Analyse de votre demande...",
    "Recherche dans les données...",
    "Construction de la réponse...",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setStep((prev) => (prev + 1) % steps.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [steps.length]);

  return (
    <Fade in={true}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 3 }}>
        {/* Avatar */}
        <Avatar sx={{ 
          bgcolor: 'common.white',
          color: 'primary.main',
          boxShadow: theme.shadows[2],
          width: 40,
          height: 40
        }}>
          <BotIcon />
        </Avatar>

        {/* Typing indicator */}
        <Paper
          elevation={1}
          sx={{
            p: 2,
            borderRadius: 3,
            borderTopLeftRadius: 0,
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'grey.200',
            display: 'flex',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Box sx={{ animation: 'spin 2s linear infinite', display: 'flex' }}>
            <LoaderIcon color="primary" fontSize="small" />
          </Box>
          <style>
            {`
              @keyframes spin {
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
          
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="body2" color="text.secondary" fontWeight={500}>
              {steps[step]}
            </Typography>
            <Box sx={{ display: 'flex', gap: 0.5, mt: 1 }}>
              <Box sx={{ width: 6, height: 6, bgcolor: 'primary.main', borderRadius: '50%', animation: 'bounce 1.4s infinite ease-in-out both' }} />
              <Box sx={{ width: 6, height: 6, bgcolor: 'primary.main', borderRadius: '50%', animation: 'bounce 1.4s infinite ease-in-out both', animationDelay: '0.16s' }} />
              <Box sx={{ width: 6, height: 6, bgcolor: 'primary.main', borderRadius: '50%', animation: 'bounce 1.4s infinite ease-in-out both', animationDelay: '0.32s' }} />
            </Box>
          </Box>
        </Paper>
      </Box>
    </Fade>
  );
};

export default TypingIndicator;
